import React from 'react';
import {
  Bar,
  BarChart,
  Area,
  AreaChart,
  Line,
  LineChart,
  CartesianGrid,
  Legend,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';
import { getNumericKeys, getColorForKey } from '../../utils/chartUtils';
import { CustomTooltip } from './CommonComponents';


// TIME-SERIES CHART COMPONENTS


/**
 * Render chart for time-series data (User Count, etc.)
 */
export const TimeSeriesChart = ({ 
  data, 
  chartType, 
  compact, 
  chartMargin, 
  responsiveProps,
  xAxisProps,
  yAxisProps,
  tooltipProps,
  legendProps 
}) => {
  const numericKeys = getNumericKeys(data);
  const xAxisKey = 'event_time';

  // Determine chart configuration based on type
  const getChartConfig = () => {
    switch (chartType) {
      case "line":
        return {
          ChartComponent: LineChart,
          DataComponent: Line,
          dataProps: (key, index) => ({
            type: "monotone",
            stroke: getColorForKey(key, index),
            strokeWidth: 2,
            activeDot: { r: 6 },
            dot: { r: compact ? 2 : 3 }
          })
        };
      case "area":
        return {
          ChartComponent: AreaChart,
          DataComponent: Area,
          dataProps: (key, index) => ({
            type: "monotone",
            stroke: getColorForKey(key, index),
            fill: getColorForKey(key, index),
            fillOpacity: 0.6,
            strokeWidth: 2
          })
        };
      default: // stacked bar
        return {
          ChartComponent: BarChart,
          DataComponent: Bar,
          dataProps: (key, index) => ({
            fill: getColorForKey(key, index)
          })
        };
    }
  };

  const { ChartComponent, DataComponent, dataProps } = getChartConfig();

  return (
    <ResponsiveContainer {...responsiveProps}>
      <ChartComponent data={data} margin={chartMargin}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        
        <XAxis
          dataKey={xAxisKey}
          {...xAxisProps}
          label={!compact ? {
            value: "Time",
            position: 'insideBottom',
            offset: -5,
            style: { fontSize: 12 }
          } : undefined}
        />
        
        <YAxis 
          {...yAxisProps}
          label={!compact ? {
            value: "Count",
            angle: -90,
            position: "insideLeft",
            style: { fontSize: 12 }
          } : undefined}
        />
        
        <CustomTooltip dataFormat="time-series" {...tooltipProps} />
        
        <Legend {...legendProps} />

        {numericKeys.map((key, index) => (
          <DataComponent
            key={key}
            dataKey={key}
            name={key.charAt(0).toUpperCase() + key.slice(1)}
            stackId={chartType === "line" ? undefined : "a"}
            {...dataProps(key, index)}
          />
        ))}
      </ChartComponent>
    </ResponsiveContainer>
  );
};
